import { IconWithText } from 'common/icon/icon-with-text.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { predicateNumber } from 'utilities/isType.js';
import { MarkerComponentType } from './utils.js';

export type FreezingLevelItem = {
  key: MarkerComponentType.FreezingLevel;
  index: string;
  freezingLevel: number;
};

export const hasFreezingLevel = ({ value, label, type }: ILocationSummary): FreezingLevelItem | undefined => {
  if ('freezingLevel' in value && predicateNumber(value.freezingLevel)) {
    return {
      key: MarkerComponentType.FreezingLevel,
      index: `${type}-${label}`,
      freezingLevel: value.freezingLevel,
    };
  }
};

export const FreezingLevel = ({ freezingLevel }: FreezingLevelItem) => {
  return (
    <IconWithText
      icon="freezing-level"
      classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-mL-xs svg-fill-textSlate"
      contentClass="u-textRegular"
      iconClass="svg-fill-textSlate"
    >
      {freezingLevel}
    </IconWithText>
  );
};
